import React, { useMemo } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import EditIcon from '@mui/icons-material/Edit';
import SendIcon from '@mui/icons-material/Send';
import Stack from '@mui/material/Stack';
import GroupIcon from '@mui/icons-material/Group';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import { faker } from '@faker-js/faker';
import SolveQuestionDialog from './SolveQuestionDialog';
import HintDialog from './HintDialog';
import HowToPlay from './HowToPlayDialog';
import { useQuestionStore } from '../../store/useQuestionStore';
import { QUESTION_STATE_SCENARIOS, QUESTION_TYPES } from '../../constants/appConstants';

export function SubmitQuestionContainer({
  options,
  settings,
  isVoteSubmitted,
  handleSubmitVote,
  questionType,
  setSolvingMethod,
  solvingMethod,
  questionIndex
}) {

  const numberVotes = useMemo(() => {
    return faker.number.int({ min: 100, max: 1000 })
  }, [options])

  const questionStore = useQuestionStore()
  const currentState = questionStore.questionState['0']
  const isStarted = currentState['started'] || !settings.isStartButtonRequired
  const answerState = currentState?.answerState
  const { NOT_STARTED, PARTIALLY_SOLVED: PARTIALLY_VALID, SOLVED_COMPLETELY } = QUESTION_STATE_SCENARIOS
  const isSolvedState = answerState === SOLVED_COMPLETELY


  console.log("SubmitQuestionContainer questionType1", questionType, currentState['started']);

  return <>
    <Grid container spacing={2} sx={{ mt: 1, mb: 1, ml: 0.5 }}>
      {!isVoteSubmitted &&
        <> {isStarted && <>
          {isSolvedState ? <Button variant="contained" endIcon={<SendIcon />} onClick={handleSubmitVote}>
            Submit
          </Button> : <SolveQuestionDialog settings={settings} questionType={questionType}
            handleSubmitVote={handleSubmitVote}
            setSolvingMethod={setSolvingMethod} solveButtonText='Submit' incompleteText="Puzzle is not solved."/>}
          {/* <Button variant="contained" endIcon={<SendIcon />} onClick={handleSubmitVote}>
            Submit
          </Button> */}
          {/* <SolveQuestionDialog settings={settings} questionType={questionType}
            handleSubmitVote={handleSubmitVote}
            setSolvingMethod={setSolvingMethod} solveButtonText='Submit' incompleteText="Puzzle is not solved."/> */}
          <SolveQuestionDialog settings={settings} questionType={questionType}
            handleSubmitVote={handleSubmitVote}
            setSolvingMethod={setSolvingMethod} />
          {<HintDialog handleVideoAdComplete={() => { handleSubmitVote() }}
            settings={settings} questionType={questionType} handleSubmitVote={handleSubmitVote} />}
        </>}
          {<HowToPlay settings={settings} questionType={questionType} />}
        </>}


      <Stack direction="row" spacing={0} sx={{ mt: 1 }}>
        <GroupIcon />
        <Typography>
          {numberVotes} answers
        </Typography>
      </Stack>
    </Grid>
  </>
}